import Api from "@/api/api";

export default {
    getUserRoles () {
        return Api.get('/api/Role/GetRoles');
    },
    getUsers () {
        return Api.get('/api/User/getUsers');
    },
    getUsersById (id) {
        return Api.get(`/api/User/GetUserByID/${id}`);
    },
    addUser (body) {
        return Api.post('/api/User/AddUser', body);
    },
    updateUser (id, body) {
        return Api.put(`/api/User/UpdateUser/${id}`, body);
    },
    removeUser (id) {
        return Api.delete(`/api/User/DeleteUser/${id}`);
    },
}